import BaseUI from "../../../core/src/ui/BaseUI";
import { UIStates, UIModes } from "../../../core/src/ui/UIStates";
import ViewManager from "../../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../../core/src/utils/Layers";
import { UIButtons } from "../../../core/src/ui/UIButtons";
import { Commands } from "../../../core/src/commands/CommandEnum";
import { UIUpdateEvent } from "../../../core/src/ui/UIUpdateEvents";
import { UIComponents } from "../../../core/src/ui/UIComponents";
import SpinModel from "../../../core/src/model/SpinModel";
import BetModel from "../../../core/src/model/BetModel";
import SoundVars from "../../../core/src/const/SoundVars";
import TextField from "../../../core/src/views/components/TextField";
import AutoplayModel from "../../../core/src/model/AutoplayModel";
import VendorModel from "../../../server/model/VendorModel";
import SwitchButton from '../../../core/src/views/components/SwitchButton';
import PointerEvents from '../../../core/src/const/PointerEvents';
import GameModel from "../../../core/src/model/GameModel";
import App from "../../../core/src/App";
import GameEvents from "../../../core/src/const/GameEvents";
import SoundController from "../../../core/src/utils/SoundController";
import { ConfigurationTypes } from '../../../core/src/const/ConfigurationTypes';
import ConfigManager from '../../../core/src/managers/ConfigManager';
import IVendorClientConfigRequestData from '../../../server/requests/contracts/IVendorClientConfigRequestData';

export default class UIDesktop extends BaseUI {
    private autoSpinCounts: TextField;
    public create(): void {
        super.create();
        this.scene = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
        this.scene.buttons.forEach((btn) => {
            this.buttons.push(btn);
            this.elements.push(btn);
        });
        this.autoSpinCounts = this.scene.sceneTextFields.get(
            "autoCount"
        ) as TextField;
        this.assignInterraction(
            Commands.SPIN,
            this.scene.buttons.get(UIButtons.Spin)
        );
        this.assignInterraction(
            Commands.STOP_AUTOPLAY,
            this.scene.buttons.get(UIButtons.StopAutoplay),
            SoundVars.BUTTON_CLICK
        );
        //    this.assignInterraction(Commands.TOGGLES_S, this.scene.buttons.get(UIButtons.StopAutoplay), SoundVars.BUTTON_CLICK);
        if (!ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable) {
            this.assignInterraction(
                Commands.TOGGLE_AUTOPLAY_SETTINGS,
                this.scene.buttons.get(UIButtons.AutoPlay),
                SoundVars.BUTTON_CLICK
            );
        }
        this.assignInterraction(
            Commands.TOGGLE_SETTINGS,
            this.scene.buttons.get(UIButtons.Settings),
            SoundVars.BUTTON_CLICK
        );
        this.assignInterraction(
            Commands.TOGGLE_BET_SETTINGS,
            this.scene.buttons.get(UIButtons.Bet),
            SoundVars.BUTTON_CLICK
        );
        this.assignInterraction(
            Commands.TOGGLE_MASTER_SOUND,
            this.scene.buttons.get(UIButtons.Sound),
            SoundVars.BUTTON_CLICK
        );
        if (GameModel.canSkipSpin()) {
            this.assignInterraction(
                Commands.TOGGLE_TURBO_SPIN,
                this.scene.buttons.get(UIButtons.Stop)
            );
        }
        this.setBehaviours();
        this.setFreeSpinsMode();

        if (GameModel.forceEnableRules()) {
            this.behaviourMapMaster.forEach((masterMap) => {
                masterMap.forEach((pattern, state) => {
                    if (state != UIStates.ERROR) {
                        pattern.addMask({
                            uiToDisable: [
                                this.scene.buttons.get(UIButtons.Settings),
                            ],
                        });
                    }
                });
            });
        }

        let masterSoundButton = this.scene.buttons.get(
            UIButtons.Sound
        ) as SwitchButton;

        masterSoundButton.switch(!SoundController.isSoundEnabled);

        masterSoundButton.on(PointerEvents.DOWN, () => {
            console.log("master sound button on click toggle");
            // masterSoundButton.toggle();
            masterSoundButton.switch(!SoundController.isSoundEnabled);
        });

        App.dispatcher.on(
            GameEvents.SOUNDS_MUTED,
            () => {
                console.log("Sound muted");
                masterSoundButton.switch(true);
            },
            this
        );

        App.dispatcher.on(
            GameEvents.SOUNDS_UNMUTED,
            () => {
                console.log("Sound unmuted");
                masterSoundButton.switch(false);
            },
            this
        );
        // TODO think of having a config for that
    }

    public update(event: UIUpdateEvent, props?: any): void {
        if (this.scene) {
            switch (event) {
                case UIUpdateEvent.TempWin:
                    this.scene.sceneMoneyFields.get(UIComponents.Win).value =
                        SpinModel.tempWinAmount;
                    break;
                case UIUpdateEvent.Balance:
                    this.scene.sceneMoneyFields.get(
                        UIComponents.Balance
                    ).value = BetModel.balance;
                    this.autoSpinCounts.text = AutoplayModel.isAutoSpinActive()
                        ? AutoplayModel.getAutoSpinNum().toString()
                        : "";
                    break;
                case UIUpdateEvent.Bet:
                    this.scene.sceneMoneyFields.get(
                        UIComponents.TotalBet
                    ).value = BetModel.totalBet;
                    break;
                case UIUpdateEvent.ClearWin:
                    this.scene.sceneMoneyFields.get(UIComponents.Win).value = 0;
                    break;
                case UIUpdateEvent.Win:
                    this.scene.sceneMoneyFields.get(
                        UIComponents.Win
                    ).value = SpinModel.isInFreespins()? SpinModel.freespinWinnings : SpinModel.getAccumulatedWin();
                    break;
                case UIUpdateEvent.FreeGames:
                    this.scene.sceneTextFields.get(
                        UIComponents.FreeGames
                    ).text = VendorModel.freeGames
                        ? VendorModel.freeGames.spins.toString()
                        : "";
                    break;
                    case UIUpdateEvent.FreeSpins:
                        this.scene.sceneTextFields.get(UIComponents.FreeSpins).text =
                        props ? props : SpinModel.freespinsNum.toString();
                    break;
                case UIUpdateEvent.ClearFreeSpins:
                    this.scene.sceneTextFields.get(
                        UIComponents.FreeSpins
                        ).text = "0";
                break;
                case UIUpdateEvent.All:
                    this.scene.sceneMoneyFields.get(
                        UIComponents.Balance
                    ).value = BetModel.balance;
                    this.scene.sceneMoneyFields.get(
                        UIComponents.TotalBet
                    ).value = BetModel.totalBet;
                    this.scene.sceneMoneyFields.get(
                        UIComponents.Win
                    ).value = SpinModel.getAccumulatedWin();
                    this.scene.sceneTextFields.get(
                        UIComponents.FreeGames
                    ).text = VendorModel.freeGames
                        ? VendorModel.freeGames.spins.toString()
                        : "";
                    this.autoSpinCounts.text = "";
                    break;
            }
        }
    }

    protected setBehaviours() {
        this.setBehaviour(UIStates.IDLE, {
            uiToEnable: ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable ?
                [
                    this.scene.buttons.get(UIButtons.Sound),
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.buttons.get(UIButtons.Bet)
                ] : [
                    this.scene.buttons.get(UIButtons.Sound),
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.buttons.get(UIButtons.Bet)
                ],
            uiToDisable: ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable?
                [
                  this.scene.buttons.get(UIButtons.AutoPlay),
                  this.scene.buttons.get(UIButtons.Stop),
                  this.scene.buttons.get(UIButtons.StopAutoplay),
                ] : [
                  this.scene.buttons.get(UIButtons.Stop),
                  this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            uiToShow: [
                this.scene,
                this.scene.buttons.get(UIButtons.Sound),
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.Bet),
                this.scene.groups.get(UIComponents.BetInfoGroup)
            ],
            uiToHide: [
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.StopAutoplay),
                this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                this.scene.groups.get(UIComponents.FreeGamesInfoGroup)
            ],
        });
        this.setBehaviour(UIStates.SPIN, {
            uiToDisable: this.buttons,
        });
        this.setBehaviour(UIStates.SPIN_RESULT, {
            uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
            uiToEnable:  GameModel.canSkipSpin() ? [
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.Sound)
              ] : [
                this.scene.buttons.get(UIButtons.Sound)
              ],
            uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.SPIN_END, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.STOP_SPIN, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        // this.setBehaviour(UIStates.WIN, {
        //     uiToShow: [this.win]
        // });

        this.setBehaviour(UIStates.FREE_SPINS, {
            uiToHide: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.StopAutoplay),
                this.scene.groups.get(UIComponents.BetInfoGroup)

            ],
            uiToShow: [
                this.scene.groups.get(UIComponents.FreeSpinsInfoGroup)
            ]
        });

        this.setBehaviour(UIStates.AUTO, {
            uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
            uiToShow: [
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ],
            uiToHide: [this.scene.buttons.get(UIButtons.Spin),this.scene.buttons.get(UIButtons.Stop)],
            uiToDisable: [
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet),
            ],
        });

        this.setBehaviour(UIStates.HIDDEN, {
            uiToHide: [this.scene],
        });
        // this.setPromotionBehaviours();
    }

    protected setPromotionBehaviours() {
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToEnable: [
                    this.scene.buttons.get(UIButtons.Spin),
                    // this.scene.buttons.get("stop_freegames")
                    ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get("stop_freegames"),// TEMP
                ],
                uiToShow: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.buttons.get("stop_freegames"),// TEMP
                    this.autoSpinCounts,
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup)
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToDisable: this.buttons,
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
                uiToEnable: [this.scene.buttons.get(UIButtons.Stop)],
                uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.STOP_SPIN,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.HIDDEN,
            {
                uiToHide: [this.scene],
            },
            UIModes.PROMOTION_SPINS
        );
    }

    protected setFreeSpinsMode() {
        let bonusBts = [...this.buttons];
        bonusBts.splice(bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),1);
        bonusBts.splice(bonusBts.indexOf(this.scene.buttons.get(UIButtons.Sound)),1);
        this.setBehaviour(UIStates.IDLE, {
            uiToHide: [...bonusBts,this.autoSpinCounts],
        },UIModes.FREE_SPINS);
        this.setBehaviour(UIStates.FREE_SPINS, {
            uiToHide: [

                this.scene.groups.get(UIComponents.BetInfoGroup)

            ],
            uiToDisable:[
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ],
            uiToShow: [
                this.scene.groups.get(UIComponents.FreeSpinsInfoGroup)
            ]
        },UIModes.FREE_SPINS);
        this.setBehaviour(UIStates.SPIN, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Settings)],
            uiToHide:  [...bonusBts,this.autoSpinCounts]
        },UIModes.FREE_SPINS);
        this.setBehaviour(UIStates.SPIN_RESULT, {
            uiToHide:  [...bonusBts,this.autoSpinCounts]
        },UIModes.FREE_SPINS);
        this.setBehaviour(UIStates.SPIN_END, {
            uiToEnable: [this.scene.buttons.get(UIButtons.Settings)],
            uiToHide: [...bonusBts,this.autoSpinCounts]
        },UIModes.FREE_SPINS);
    }
}
